import { useEffect, useState } from 'react'
import { View } from 'react-native'

import { BaseModalConfig } from '..'
import { translate } from '../../../../../i18n'
import { ConfirmOption } from '../../../BottomModalContent/Content'
import { styles } from './RemovedByTeacher.style'
import { DS } from '../../../../../design-system'
import { ProgressBar } from '../../../ProgressBar'

export interface RemovedByTeacherProps extends BaseModalConfig {
  confirm: ConfirmOption
}

export const RemovedByTeacher = ({ confirm }: RemovedByTeacherProps) => {
  const maxTime = 5 * 1000
  const [timeLeft, setTimeLeft] = useState(maxTime)

  useEffect(() => {
    if (timeLeft === 0) return

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1000)
    }, 1000)

    return () => clearInterval(timer)
  }, [timeLeft])

  return (
    <View style={styles.modalContainer}>
      <DS.Frame style={[styles.container, { alignItems: 'center', gap: DS.spacing[8] }]}>
        <DS.Icon name="Minus--enclosed" width={40} height={40} />
        <DS.Text variant="Heading 3/Medium" style={{ textAlign: 'center' }}>
          {translate('gameScreen.removedFromGameByTeacher.title')}
        </DS.Text>
        <DS.Text variant="Body Small/Regular">
          {translate('gameScreen.removedFromGameByTeacher.messageReturn')}
        </DS.Text>
        <DS.Frame style={{ height: 8, width: '100%', marginVertical: DS.spacing[8] }}>
          <ProgressBar
            duration={timeLeft}
            maxDuration={maxTime}
            color={'Brand/Orange'}
            backgroundColor="Global/Black"
            backgroundOpacity={0.5}
            onComplete={confirm.onPress}
          />
        </DS.Frame>
        <DS.Button variant="Large/Primary" type="On Light" onPress={confirm.onPress}>
          {translate('gameScreen.removedFromGameByTeacher.goToPlay')}
        </DS.Button>
      </DS.Frame>
    </View>
  )
}
